import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import appReducer from './app.reducer';
import resourcesReducer from './resources.reducer';
import authReducer from './auth.reducer';
import reportsReducer from './reports.reducer';

export default combineReducers({
  // Global layout changes and interactions
  app: appReducer,
  resources: resourcesReducer,
  router: routerReducer,
  auth: authReducer,
  reports: reportsReducer,
});



// WEBPACK FOOTER //
// ./src/store/reducers/index.js